import React, {useState, useEffect, useRef, useMemo, useCallback} from 'react'
import HeadDetails from "../Layout/Head";
import Scripts from "../Layout/Head/Scripts";
import BannerBloc from "../Layout/Header/BannerBloc";
import Utils from "@/utils/Default/Utils";
import Header from "../Layout/Header/Header";
import MenuContainer from "../Common/Menu/MenuContainer";
import Footer from "../Layout/Footer/Footer";
import {Breadcrumb} from '../Common/Breadcrumb';
import {BackToTop} from '../Common/BackToTop';
import {Title} from "./Title";
import {ShopBanner} from "./ShopBanner";
import {PreFilter} from './PreFilter';
import FilterBar from './FilterBar';
import {FilterModal} from './FilterModal';
import {SeoInfo} from './SeoInfo';
import {SeoKeyWord} from './SeoKeyWord';
import {connect,useDispatch} from "react-redux";
import {initAppDataKeyValues} from "@/animations/Default/commonPage";
import {getTrackingData} from "@/redux/reducers/Default/tracking/trackingActions";
import {getDefaultMenu, updateShowPriceWithoutTax} from "@/redux/reducers/Default/header/headerActions";
import PropTypes, {object} from "prop-types";
import Script from "next/script";
import ProductListContainer from "./ProductListContainer";
import {getCookieValue, setCookieValue} from "../../../animations/Default/commonPage"
import {
    RENDER_MODE_PREFELTER,
    MAX_NUMBER_PREFELTER,
    FILTER_AVAILABILITY_SHOP_ID_LIST_CODE,
    FILTER_PRICE_CODE,
    NAVIGATION_PAGE
} from "@/utils/constants";
import {fechFiltredProductListItems} from "../../../redux/reducers/Default/productList/productListActions";
import {
    initTargetToSell,
    refreshT2S,
    triggerAppliedFilters, triggerAvailabilityShopFilter,
    triggerRemoveAppliedFilters
} from "@/animations/Default/productListPage";
import {HANDLEAPISTATUSPENDING} from "../../../redux/reducers/Default/actionsTypes";
import LoadingProgressiveResource from "../Layout/Resource/LoadingProgressiveResource";
import {prepareMenuItemsByMenuIdNav} from "@/utils/Mobile/utils";
import EmptyProductList from "./EmptyProductList";
import {getBuildId} from "@/utils/communUtil";
import {triggerRemoveAllAppliedFilters} from "@/animations/Mobile/productListAnimations";



const DefaultProductListPage = ({
                                    context,
                                    showBanners,
                                    bannersBlocList,
                                    getTrackingData,
                                    menuItems,
                                    aboveMenuItems,
                                    footerTrackingFlow,
                                    productsListData,
                                    desactivateT2s,
                                    isEmptyProductList,
                                    category,
                                    isAvailabilityFilterActif,
                                    adsenseStatus,
                                    currentFiltersValue,
                                    shop,
                                    customer,
                                    showPreviousPage,
                                    fechFiltredProductListItems,
                                    isDQENormalisationActive,
                                    metaDescription,
                                    seoLinks,
                                    handleApiStatusPending,
                                    changeFromClient,
                                    deviceType,
                                    userAgent,
                                    isCustomMenu,
                                    updateShowPriceWithoutTax
                                }) => {
    const availabilityDisplayMode = productsListData.availabilityDisplayMode
    const firstRadioSort = "Top ventes"
    const defaultRadioSort = [null,"Top ventes",null,""]
    const inputSearch = useRef(null);
    const filterScrollEl = useRef();
    const [newProductsListData, setNewProductsListData] = useState(productsListData)
    const [showModal, setShowModal] = useState('close')
    const [filterSelected, setFilterSelected] = useState(null)
    const [accordion, setAccordion] = useState(null)
    const [sortSelected, setSortSelected] = useState(firstRadioSort)
    const [filterBrands, setFilterBrands] = useState('')
    const dispatch = useDispatch();
    const [isProductListEmpty, setIsProductListEmpty] = useState(false);
    const [htOptin, setHtOptin] = useState(false);

    const handleChangeOptionHT = useCallback((value) => {
        if (value) {
            setHtOptin(true);
            appData.actionTrigger.dispatch({
                trigger: "handleClickWithoutTaxPrice"
            });
            setCookieValue('DisplayPriceWithoutTax', 1);
            updateShowPriceWithoutTax(true);
        } else {
            setHtOptin(false);
            setCookieValue('DisplayPriceWithoutTax', 0);
            updateShowPriceWithoutTax(false);
        }
    },[])


    useEffect(() => {
        setHtOptin(getCookieValue('DisplayPriceWithoutTax') === "1");
            dispatch(getDefaultMenu(deviceType,userAgent));
        let levels = [productsListData.firstLevelLabel, productsListData.secondLevelLabel, productsListData.thirdLevelLabel]
        let t2SellParams = {
            userGroup: customer.group,
            wordingVersion: 'Default',
            webUserId: Utils.getUserIdFromCookie(),
            itemList: productsListData.listItems.values,
            levels: levels
        };
        initTargetToSell('ProductsList', t2SellParams)
        initAppDataKeyValues(productsListData.navigationMetaInfosConfigs, productsListData.octipasPayload, productsListData.trackingUrlFapi, 'ProductsList', productsListData.mvcUrl, isDQENormalisationActive, productsListData.shopCircleVersion, productsListData.logoVersion,  null, context, availabilityDisplayMode)
        getTrackingData(productsListData.mvcUrl)

       if (productsListData.sortsCriteria && productsListData.filters.values?.length > 0 && productsListData?.filters?.values[0][1] !== "Trier") {
           let copyProductListData = Object.assign({}, JSON.parse(JSON.stringify(productsListData)));
            const newKeySort = copyProductListData.sortsCriteria.map((element, index) => {
                let isApplied = (index == 0) ? true : false ;
                return (["Trier",element.label,"Trier",element.value,null,isApplied,{codes: Array(0), items: Array(0)},null]) });
            const sortValues = [ "Trier","Trier","Multi",null,{codes: Array(0), items: Array(0)},newKeySort,"Trier" ]
            copyProductListData.filters.values.unshift(sortValues)
            copyProductListData.filters.values = copyProductListData.filters.values.filter(item => item[1] !== FILTER_AVAILABILITY_SHOP_ID_LIST_CODE)
            setNewProductsListData(copyProductListData)
        }
    }, []);

    useEffect(() => {
        if (productsListData.sortsCriteria && productsListData?.filters?.values?.length > 0 && productsListData.filters.values[0][1] !== "Trier") {
            let copyProductListData = Object.assign({}, JSON.parse(JSON.stringify(productsListData)));
           const newKeySort = copyProductListData.sortsCriteria.map((element, index) => {
                let isApplied = (index == 0) ? true : false ;
                return (["Trier",element.label,"Trier",element.value,null,isApplied,{codes: Array(0), items: Array(0)},null]) });
            const sortValues = [ "Trier","Trier","Multi",null,{codes: Array(0), items: Array(0)},newKeySort,"Trier" ]
            copyProductListData.filters.values.unshift(sortValues)
            copyProductListData.filters.values = copyProductListData.filters.values.filter(item => item[1] !== FILTER_AVAILABILITY_SHOP_ID_LIST_CODE)
            setNewProductsListData(copyProductListData)
        }
    }, [productsListData]);
    useEffect(() => {
        if (isEmptyProductList !== isProductListEmpty) {
            document.body.classList.remove('filter-modal-active');
            setShowModal('close');
            setIsProductListEmpty(isEmptyProductList)
            let showT2S = productsListData.appliedFiltersValues ? (Object.keys(productsListData.appliedFiltersValues).length <= 1 ? true : false) : false;
            if (isEmptyProductList) {
                let productListItemsT2S = productsListData?.listItems ? productsListData?.listItems?.values : [];
                let currentSort = productsListData.currentSort;
                refreshT2S({currentSort}, productListItemsT2S, showT2S);
            }
        }
    }, [isEmptyProductList]);

    const {
        metaTitle,
        logoVersion,
        headerTrackingScopeData,
        footerTrackingScopeData,
        filters,
        adaptiveLoadingResources
    } = productsListData
    let categoryLabel = productsListData.category.label ? productsListData.category.label : productsListData.lastLevelLabel
    let shopBannerContent = Utils.getMetaInfosValueByCode('BandeauPresentation', productsListData?.category?.metaInfos)
    let htmlRelatedContent = Utils.getMetaInfosValueByCode("htmlRelatedContent", productsListData?.metaInfos)
    let notAvailabilityFilters = useMemo(() => productsListData.appliedFiltersValues.filter(item => item.filterCode !== FILTER_AVAILABILITY_SHOP_ID_LIST_CODE), [productsListData.appliedFiltersValues])
    let concernedFilters = useMemo(() =>
            productsListData.filters.values.filter(item => Utils.getMetaInfosValueByCode('renderMode', item[4]) === RENDER_MODE_PREFELTER),
        [productsListData.filters])
    let availabilityFilter = useMemo(() =>
        filters.values.filter(item => item[1] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE)
    , [filters.values]);
    const euroPricesRange = useMemo(() => new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0
    }), []);

    const filterModal = useCallback((filterName) => {
        setFilterSelected(filterName)
        setFilterBrands("")
        if (inputSearch.value) {
            inputSearch.current.value = '';
        }
        if (showModal == 'open') {
            document.body.classList.remove('filter-modal-active');
            setShowModal('close');
        } else {
            document.body.classList.add('filter-modal-active');
            setShowModal('open')
            filterScrollEl.current.scrollTo(0, 0)
        }
    }, [inputSearch, showModal]);


    const getPriceRangeValue = (code) => {
        let copyNewProductsListData = { ...newProductsListData }
        const value = copyNewProductsListData.filters.values.filter(item => item[1] == FILTER_PRICE_CODE)[0][5].filter(item => item[2] == code)[0]
        if (value) {
            return value
        }
        return null
    }

    const resetPriceAppliedValues = () => {
        let copyNewProductsListData = { ...newProductsListData }
        copyNewProductsListData.appliedFiltersValues.splice(copyNewProductsListData.appliedFiltersValues.findIndex(item => item.filterCode === FILTER_PRICE_CODE), 1)
        if (copyNewProductsListData.filters.values.filter(item => item[1] == FILTER_PRICE_CODE).length > 0) {
            let prices = copyNewProductsListData.filters.values.filter(item => item[1] == FILTER_PRICE_CODE)[0][5]
            for (var i = 0; i < prices.length; i++) {
                if (prices[i][2] === "MinAppliedValue") {
                    copyNewProductsListData.filters.values.filter(item => item[1] == FILTER_PRICE_CODE)[0][5].splice(i, 1);
                    i--;
                }
                if (prices[i][2] === "MaxAppliedValue") {
                    copyNewProductsListData.filters.values.filter(item => item[1] == FILTER_PRICE_CODE)[0][5].splice(i, 1);
                    i--;
                }
            }
        }
        setNewProductsListData(copyNewProductsListData)

    }

    const createObjectFilterPrice = (code, label, value) => {
               return (["Prix",label,code,value,"€",true,null,null])
    }
    const formatObjectFilterPrice = (code, label, value) => {
        return (
            {
                category: "Prix",
                code: code,
                filterCode: FILTER_PRICE_CODE,
                isApplied: true,
                itemsCount: null,
                label: label,
                unit: "€",
                value: value
            }
        )

    }
    const addFilterPrice = (event) => {
        //todo here change value with the same  value format  in API
        let copyNewProductsListData = { ...newProductsListData }
        let priceAppliedFiltersValues = createObjectFilterPrice(
            `de-${Math.floor(event[0])}-a-${Math.ceil(event[1])}`,
            `de ${Math.floor(event[0])} à ${Math.ceil(event[1])}`,
            `NW-74-prix~de-${Math.floor(event[0])}-a-${Math.ceil(event[1])}~euros`
        )
        let formatedPriceValues = formatObjectFilterPrice(
            `de-${Math.floor(event[0])}-a-${Math.ceil(event[1])}`,
            `de ${Math.floor(event[0])} à ${Math.ceil(event[1])}`,
            `NW-74-prix~de-${Math.floor(event[0])}-a-${Math.ceil(event[1])}~euros`
        )
        let MinAppliedValue = createObjectFilterPrice(
            "MinAppliedValue",
            `de ${Math.floor(event[0])} à ${Math.ceil(event[1])}`,
            `${Math.floor(event[0])}`
        )
        let MaxAppliedValue = createObjectFilterPrice(
            "MaxAppliedValue",
            `de ${Math.floor(event[0])} à ${Math.ceil(event[1])}`,
            `${Math.ceil(event[1])}`
        )
        copyNewProductsListData.appliedFiltersValues.push(formatedPriceValues)
        copyNewProductsListData.filters.values.filter(item => item[1] == FILTER_PRICE_CODE)[0][5].push(MinAppliedValue, MaxAppliedValue)
        setNewProductsListData(copyNewProductsListData);
        priceAppliedFiltersValues[2] = FILTER_PRICE_CODE;
        addFilter(event,priceAppliedFiltersValues)
    }
    const atLeastOneFilterAvailabilityActive = (filerItem, appliedFilters) => {
        for (let i = 0; i < filerItem.length; i++) {
            if (appliedFilters[filerItem[i].code]) {
                return true;
            }
        }
        return false
    }
    const addFilter = useCallback((event,filterItem) => {
        let appliedFilters = {...currentFiltersValue}
            if (filterItem[2] == FILTER_PRICE_CODE) {
                delete appliedFilters[filterItem[2]];
            }

            if (!appliedFilters[filterItem[2]]) {
                appliedFilters[filterItem[2]] = [];
            }
            let index = appliedFilters[filterItem[2]].indexOf(filterItem[3]);
            if (index > -1) {
                appliedFilters[filterItem[2]].splice(index, 1);
            } else {
                appliedFilters[filterItem[2]].push(filterItem[3]);
            }

            if (appliedFilters[filterItem[2]].length === 0) {
                delete appliedFilters[filterItem[2]];
            }

         let currentSort =  [null,productsListData.currentSort.label,null,productsListData.currentSort.value]
        handleApiStatusPending(true);
        fechFiltredProductListItems(null, productsListData.pager, currentSort, 1, appliedFilters, filterItem, productsListData.id)

    },[currentFiltersValue,productsListData.currentSort,productsListData.pager, productsListData.id])

    const applyFilters = useCallback((event, filterItem, action = "apply", itemFilterName) => {
        if (action === 'remove') {
            removeFilter(event, filterItem)
            triggerRemoveAppliedFilters(itemFilterName)
        } else {
            addFilter(event, filterItem)
            if (itemFilterName !== FILTER_AVAILABILITY_SHOP_ID_LIST_CODE) {
                triggerAppliedFilters(itemFilterName)
            }
        }
    }, [addFilter])
    const removeAvailabilityFilterItem = (code) => {
        let copyNewProductsListData = {...newProductsListData}
        let availabilityFilter = copyNewProductsListData.filters.values.filter(item => item[1] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE);
        if (availabilityFilter?.length > 0) {
            let filterItem = availabilityFilter[0][5].filter(item => item[2] === code)
            if (filterItem?.length > 0) {
                filterItem[0][5] = false
            }
        }
        triggerAvailabilityShopFilter('filter_delete')
    }
    const removeAllAvailabilityFilterItem = () => {
        let copyNewProductsListData = {...newProductsListData}
        let availabilityFilter = copyNewProductsListData.filters.values.filter(item => item[1] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE);
        if (availabilityFilter?.length > 0) {
            availabilityFilter[0][5].map(item => {
                item[5] = false
            })
        }
        triggerAvailabilityShopFilter('filter_delete')
    }

    const removeFilter = useCallback((event,appliedFilters, filterCode) => {
        let copyNewProductsListData = {...newProductsListData}
        if (appliedFilters[0] != FILTER_PRICE_CODE) {
            if (appliedFilters[0] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE && appliedFilters[2] === 'all') {
                removeAllAvailabilityFilterItem()
            } else if (appliedFilters[0] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE && appliedFilters[2] !== 'all') {
                removeAvailabilityFilterItem(appliedFilters[2])
            } else {
                const productsListDataFilter = copyNewProductsListData.filters.values.filter(item => item[1] == appliedFilters[0])
                if (productsListDataFilter.length > 0) {
                    const filterItem = productsListDataFilter[0][5].filter(item => item[2] == appliedFilters[2])
                    if (filterItem.length > 0) filterItem[0][5] = false
                }
            }
        } else {
            resetPriceAppliedValues()
        }
        if (!!filterCode) {
            triggerRemoveAppliedFilters(filterCode)
        }
        let updateAppliedFiltersValue = appliedFilters[0] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE && appliedFilters[2] === 'all' ?
            copyNewProductsListData.appliedFiltersValues.filter(data => data.filterCode !== appliedFilters[0]) :
            copyNewProductsListData.appliedFiltersValues.filter(data => data.code !== appliedFilters[2])

        delete copyNewProductsListData.appliedFiltersValues
        setNewProductsListData(Object.assign(copyNewProductsListData, {appliedFiltersValues: updateAppliedFiltersValue}))

        /* verifier si on garde ou pas la suppression statique sans attendre la réponse API  */
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        handleApiStatusPending(true);
        let currentSort = [null, productsListData.currentSort.label, null, productsListData.currentSort.value]
        if (appliedFilters[0] === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE && appliedFilters[2] === 'all') {
            availabilityFilter[0][5].map(item => {
                if (item[2] !== 'all') {
                    if (currentFiltersValue[item[2]]) {
                        delete currentFiltersValue[item[2]]
                    }
                }
            })
            //to do here null with keyword State for search
            fechFiltredProductListItems(null, productsListData.pager, currentSort, 1, currentFiltersValue, appliedFilters, productsListData.id)
        } else {
            let code = appliedFilters[2]
            let filterToRemove = currentFiltersValue[code]
            if (!filterToRemove) {//Filter price
                code = appliedFilters[0]
                filterToRemove = currentFiltersValue[code]
            }
            if (filterToRemove) {
                delete currentFiltersValue[code]
                fechFiltredProductListItems(null, productsListData.pager, currentSort, 1, currentFiltersValue, appliedFilters, productsListData.id)
            }
        }
    }, [newProductsListData, productsListData.currentSort, productsListData.pager, productsListData.id, availabilityFilter])

    const updateFilter = useCallback((event, itemFilter, itemFilterValue) => {
        handleApiStatusPending(true);
        let copyNewProductsListData = { ...newProductsListData }
        if (itemFilterValue[5] == false) {
            itemFilterValue[5] = true
            let copyItemFilterValue = { ...itemFilterValue }
            copyItemFilterValue.category = itemFilter[0]
            copyNewProductsListData.appliedFiltersValues.push(copyItemFilterValue)
            setNewProductsListData(copyNewProductsListData)
            applyFilters(event, itemFilterValue, "apply", itemFilter[0])
        } else {
            removeFilter(event, itemFilterValue, itemFilter[0])
        }
    }, [newProductsListData])

    const removeAllFiltersActive = useCallback((event) => {
        /* verifier si on garde ou pas la suppression statique sans attendre la réponse API */
        setFilterBrands("")
        handleApiStatusPending(true)
        setSortSelected(firstRadioSort)
        setIsProductListEmpty(false)
        resetPriceAppliedValues()
        setAccordion(null)
        if (inputSearch.value) {
            inputSearch.current.value = '';
        }
        appData.actionTrigger.dispatch({
            trigger: "deleteAllFiltersClicked",
            payload: {
                eventAction: event?.target?.className === 'dp__header__filters-current__remove-all' ? 'Filtre' : 'Filtre réinitialisé'
            }
        });
        let copyNewProductsListData = {...newProductsListData}
        copyNewProductsListData.filters.values.map((itemFilter) => {
            itemFilter[5].map((item) => {
                item[5] = false
            })
        })
        copyNewProductsListData.appliedFiltersValues = []
        setNewProductsListData(copyNewProductsListData);
        triggerRemoveAllAppliedFilters()
        fechFiltredProductListItems(null, productsListData.pager, defaultRadioSort, 1, null, {filterCode: 'removeAll'}, productsListData.id)
    }, [inputSearch, newProductsListData, productsListData.pager, productsListData.id])

    const removeCurrentSort = useCallback((event) => {
        event.preventDefault();
        handleApiStatusPending(true);
        fechFiltredProductListItems(null, productsListData.pager, defaultRadioSort, 1, currentFiltersValue, null, productsListData.id)
    }, [productsListData.pager, currentFiltersValue, productsListData.id])

   const  changeSortCriteria = useCallback((event,sortItem) => {
       appData.actionTrigger.dispatch({
           trigger: "sortFilterClicked",
           payload: {
               eventLabel: sortItem[1]
           }
       });
        handleApiStatusPending(true);
        setSortSelected(sortItem[1])
        delete sortItem[5];
        fechFiltredProductListItems(null,productsListData.pager,sortItem,1, currentFiltersValue,null, productsListData.id)
    },[productsListData.pager, currentFiltersValue, productsListData.id])

    const updateChangeNouiSlider = useCallback((event, filterName) => {
        const minCurrentValue = Math.floor(event[0])
        const maxCurrentValue = Math.ceil(event[1])
        if (
            Math.floor((getPriceRangeValue('MinApplicableValue').value) == minCurrentValue) &&
            Math.ceil(getPriceRangeValue('MaxApplicableValue').value) == maxCurrentValue) {
            resetPriceAppliedValues()
            triggerRemoveAppliedFilters(filterName)
        } else {
            resetPriceAppliedValues()
            addFilterPrice(event)
            triggerAppliedFilters(filterName)
        }
    }, [])
    const memoizedLinks = useMemo(() => <link rel="stylesheet" href={"/assets/css/default/productList.css?v="+getBuildId()}/>, [])
    const memoizedScripts = useMemo(() =>
        <>
            <Script src="/assets/js/imageMapResizer.min.js" strategy="beforeInteractive"/>
            <Script src="/assets/js/owl.carousel.min.js" strategy="beforeInteractive"/>
            <Script src={"/assets/js/Default/productList.js?v="+getBuildId()}/>
            <Script type="text/tc_privacy" data-category="3" src={"/assets/js/Default/octipasMerchLibraryConfig.js?v="+getBuildId()}/>
            <LoadingProgressiveResource resourceName={'Ressource6'}
                                        resources={adaptiveLoadingResources}>
                <Script src={"/assets/js/Default/targetToSell.min.js?v="+getBuildId()} strategy="afterInteractive"/>
            </LoadingProgressiveResource>
        </>
        , [adaptiveLoadingResources])

    const memoizedTitleChildren = useMemo(() =>
            <h1 className='dp__header__title'>
                {notAvailabilityFilters && notAvailabilityFilters.length > 0 ? notAvailabilityFilters.length == 1 ? categoryLabel + ' - ' + notAvailabilityFilters[0].label + (notAvailabilityFilters[0].unit ? ' ' + notAvailabilityFilters[0].unit : '') : categoryLabel + ' - ' + notAvailabilityFilters[0].label + ' ' + (notAvailabilityFilters[0].unit ? notAvailabilityFilters[0].unit : '') + ' - ' + notAvailabilityFilters[1].label + ' ' + (notAvailabilityFilters[1].unit ? notAvailabilityFilters[1].unit : '') : productsListData.label}
            </h1>
        , [notAvailabilityFilters, categoryLabel, productsListData.label]);

    const productListParams = useMemo(() => {
        return {
            changeFromClient: changeFromClient,
            currentSort: productsListData.currentSort,
            categoryId: category.id,
            currentFiltersValue: currentFiltersValue,
            pageIndex: productsListData.pager ? productsListData.pager.currentPageIndex + 1 : null,
            pager: productsListData.pager,
            availabilityFiltersCodes: Utils.prepareAllShopsProductAvailabilityFilterValue(filters.values),
            keyWords: null
        };
    }, [changeFromClient, productsListData.pager, productsListData.currentSort, category.id, currentFiltersValue, filters.values]);
    return (
        <>
            <HeadDetails
                title={metaTitle}
                description={metaDescription}
                context={context}
                canonical={Utils.getMetaInfosValueByCode('canonicalURL', productsListData.metaInfos)}
                previousURL={Utils.getMetaInfosValueByCode('previousURL', productsListData.metaInfos)}
                nextURL={Utils.getMetaInfosValueByCode('nextURL', productsListData.metaInfos)}
            >
                {memoizedLinks}
            </HeadDetails>
            <Scripts>
                {memoizedScripts}
            </Scripts>
            <header id="main-header" className={"main-header"}>
                <div id="main-header__infobar" className="main-header__infobar owl-carousel owl-loaded">
                    <BannerBloc showBanners={showBanners} bannersBlocList={bannersBlocList}/>
                </div>
                <div id="header-tools-content">
                    <Header currentStep={context} logoVersion={logoVersion} shopCircleVersion={productsListData.shopCircleVersion}
                            headerTrackingScopeData={headerTrackingScopeData} productsListData={productsListData} />
                </div>
                <MenuContainer menuItems={menuItems} aboveMenuItems={aboveMenuItems} context = {context}/>
            </header>
            <Breadcrumb parentsCategories={productsListData.category ? productsListData.category.parentsCategories : null}
                        levelsNavigation={productsListData.levelsNavigation}/>
            {isProductListEmpty ?
                <EmptyProductList label={productsListData.label} isSearch={false} isNoResult={false}
                                  removeAllFiltersActive={removeAllFiltersActive}/>
                :
                <>
                    <div className="dp" id="conteneur_central">
                        <section>
                            <Title>
                                {memoizedTitleChildren}
                            </Title>
                            {/*Note MLE : <PreFilter/> à dynamiser par Decade* + add condition search page */}
                            {productsListData.firstLevelLabel != "boutiques" && <PreFilter
                                currentFiltersValue={currentFiltersValue}
                                maxNumberPrefelter={MAX_NUMBER_PREFELTER}
                                concernedFilters={concernedFilters}
                                applyFilters={applyFilters}
                            />}
                            <ShopBanner shopBannerContent={shopBannerContent}/>
                            <FilterBar isAvailabilityFilterActif={isAvailabilityFilterActif}
                                       availabilityDisplayMode={availabilityDisplayMode}
                                       shopInfos={shop?.shopInfos}
                                       productListParams={productListParams}
                                       applyFilters={applyFilters}
                                       availabilityFilter={availabilityFilter?.length > 0 ? availabilityFilter : null}
                                       newProductsListData={newProductsListData}
                                       productsListData={productsListData}
                                       filterModal={filterModal}
                                       euroPricesRange={euroPricesRange}
                                       setNewProductsListData={setNewProductsListData}
                                       removeAllFiltersActive={removeAllFiltersActive}
                                       removeFilter={removeFilter}
                                       setAccordion={setAccordion}
                                       sortSelected={sortSelected}
                                       setSortSelected={setSortSelected}
                                       removeCurrentSort={removeCurrentSort}
                                       firstRadioSort={firstRadioSort}
                                       handleChangeOptionHT={handleChangeOptionHT}
                                       htOptin={htOptin}
                            />
                        </section>
                        <ProductListContainer productsListData={productsListData}
                                              shopCircleVersion={productsListData.shopCircleVersion}
                                              showPreviousPage={showPreviousPage}
                                              appliedFiltersValues={productsListData.appliedFiltersValues}
                                              currentFiltersValue={productsListData.currentFiltersValue}
                                              availabilityDisplayMode={availabilityDisplayMode}
                                              desactivateT2s={desactivateT2s}
                                              adsenseStatus={adsenseStatus}
                                              adaptiveLoadingResources={adaptiveLoadingResources}
                                              madIsActifInFiltredProductList={productsListData.madIsActifInFiltredProductList}
                                              merchListItems={productsListData.merchListItems}
                                              octipasPayload={productsListData.octipasPayload}
                                              filters={productsListData.filters}
                                              htOptin={htOptin}
                                              ABTastyCookieIsActive={productsListData.ABTastyCookieIsActive}
                        />
                        <FilterModal
                            showModal={showModal}
                            filterModal={filterModal}
                            newProductsListData={newProductsListData}
                            setNewProductsListData={setNewProductsListData}
                            euroPricesRange={euroPricesRange}
                            filterSelected={filterSelected}
                            filterScrollEl={filterScrollEl}
                            removeAllFiltersActive={removeAllFiltersActive}
                            setSortSelected={setSortSelected}
                            sortSelected={sortSelected}
                            updateChangeNouiSlider={updateChangeNouiSlider}
                            accordion={accordion}
                            setAccordion={setAccordion}
                            removeFilter={removeFilter}
                            updateFilter={updateFilter}
                            changeSortCriteria={changeSortCriteria}
                            productsListData={productsListData}
                            filterBrands={filterBrands}
                            setFilterBrands={setFilterBrands}
                            inputSearch={inputSearch}
                            firstRadioSort={firstRadioSort}
                        />
                    </div>
                    {seoLinks?.length > 0 && <SeoKeyWord seoLinks={seoLinks}/>}
                    {htmlRelatedContent != null &&
                        <SeoInfo
                            relatedContentPart1={productsListData.relatedContentPart1}
                            relatedContentPart2={productsListData.relatedContentPart2}
                            htmlRelatedContent={htmlRelatedContent}
                        />}
                </>
            }
            <footer id="container_footer">
                    <div id="footer">
                        <Footer footerTrackingFlow={footerTrackingFlow}
                                footerTrackingScopeData={footerTrackingScopeData}/>
                    </div>
            </footer>
            <BackToTop/>
        </>
    )
}

DefaultProductListPage.propTypes =
    {
        context: PropTypes.string,
        mvcUrl: PropTypes.string,
    };

DefaultProductListPage.defaultProps = {};

const mapStateToProps = (state, ownProps) => {
    return {
        shop: state.header.shop,
        customer: state.header.customer,
        isEmptyProductList: state.productList?.isEmptyProductList ? state.productList.isEmptyProductList : false,
        filters: state.productList?.changeFromClient ? state.productList.productsListData?.filters?.values : ownProps.productsListData?.filters?.values,
        productsListData: state.productList && state.productList.changeFromClient ? state.productList.productsListData : ownProps.productsListData,
        seoLinks: state.productList && state.productList.changeFromClient ? state.productList.productsListData?.category?.seoLinks : ownProps.productsListData?.category?.seoLinks,
        pager: state.productList ? (state.productList.changeFromClient ? state.productList.pager : ownProps.productsListData.pager) : null,
        showBanners: ownProps.productsListData.showBanners ? ownProps.productsListData.showBanners : false,
        category: ownProps.productsListData.category,
        metaDescription: ownProps.productsListData.metaDescription ? ownProps.productsListData.metaDescription  : '' ,
        adsenseStatus: ownProps.productsListData.adsenseStatus ? ownProps.productsListData.adsenseStatus  : false ,
        bannersBlocList: ownProps.productsListData.bannersBlocList ? ownProps.productsListData.bannersBlocList  : [] ,
        showPreviousPage: ownProps.showPreviousPage,
        isDQENormalisationActive: ownProps.productsListData.isDQENormalisationActive,
        desactivateT2s: ownProps.productsListData.desactivateT2s == "1" ? 1 : 0,
        isAvailabilityFilterActif : ownProps.productsListData.isAvailabilityFilterActif ? ownProps.productsListData.isAvailabilityFilterActif : false,
        footerTrackingFlow: state.tracking.footerTrackingFlow,
        currentFiltersValue: state.productList?.currentFiltersValue,
        changeFromClient: state.productList?.changeFromClient,
        deviceType:ownProps.deviceType,
        isCustomMenu:ownProps.isCustomMenu,
        menuItems: (!state.menu.isDefaultMenu) ?  ownProps.menuItems :  state.menu.menuItems.values
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fechFiltredProductListItems: (keyWords, pager, currentSort, pageIndex, appliedFiltersValues,filterItem, categoryId) => dispatch(fechFiltredProductListItems(keyWords, pager, currentSort, pageIndex, appliedFiltersValues,filterItem, categoryId)),
        handleApiStatusPending: (apiStatusPending) => dispatch({type: HANDLEAPISTATUSPENDING, payload: {apiStatusPending: apiStatusPending}}),
        getTrackingData: (mvcUrl) => dispatch(getTrackingData(mvcUrl)),
        updateShowPriceWithoutTax: (value) => dispatch(updateShowPriceWithoutTax(value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultProductListPage);
